import { useState, useEffect } from "react";
import { ArrowUp } from "lucide-react";

/**
 * BackToTop — Floating button that scrolls to top when clicked.
 * Appears after scrolling down 600px. Smooth scroll animation.
 * Positioned above the mobile CTA bar on small screens.
 */
export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    function handleScroll() {
      setIsVisible(window.scrollY > 600);
    }

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  function scrollToTop() {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <button
      onClick={scrollToTop}
      className={`fixed z-40 w-11 h-11 flex items-center justify-center bg-white border border-gray-200 rounded-full shadow-lg hover:shadow-xl hover:border-[#2563EB]/30 transition-all duration-300 ${
        isVisible
          ? "opacity-100 translate-y-0"
          : "opacity-0 translate-y-4 pointer-events-none"
      } bottom-20 md:bottom-8 right-4 md:right-6`}
      aria-label="Tillbaka till toppen"
    >
      <ArrowUp className="w-5 h-5 text-gray-600" />
    </button>
  );
}
